module.exports = __webpack_public_path__ + "static/media/eimi-fukada-lose.3ead4b60.jpg";